import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ICustomPropertiesSectionHOCProps } from './types';
import { ICustomPropertiesSectionEvents, ICustomPropertiesSectionFields } from '../../components/CustomPropertiesSection/types';
import { CustomPropertiesSection } from '../../components/CustomPropertiesSection/CustomPropertiesSection';
import { getSectionType } from '../../../selectors/getSectionType';
import { onOpen } from './events/onOpen';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { onClickCancel } from './events/onClickCancel';
import { onClickEdit } from './events/onClickEdit';
import { onHideEmpty } from './events/onHideEmpty';
import {
    getBoardCardCustomPropertyOptions
} from '../../../../../../../store/model/board/selectors/getBoardCardCustomPropertyOptions';
import { getShowProFeaturesTrial } from '../../../../../../../store/model/authUser/selectors/getShowProFeaturesTrial';
import {
    getIsUserEssentialPlanOnly
} from '../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import {
    getUserHideEmptyCustomProperties
} from '../../../../../../../store/model/authUser/selectors/getUserHideEmptyCustomProperties';
import { onSave } from './events/onSave';
import { onConfirmDelete } from './events/onConfirmDelete';
import { onAdd } from './events/onAdd';
import {
    getCustomPropertiesCreateSelector
} from '../../../../../base/components/CustomProperties/hocs/selectors/getCustomProperties';

const mapStateToProps = () => {
    const getCustomProperties = getCustomPropertiesCreateSelector();

    return (
        state: IApplicationState,
        { boardId, cardId, sectionType: sectionTypeOwn }: ICustomPropertiesSectionHOCProps
    ): ICustomPropertiesSectionFields => {
        const sectionType = getSectionType(state, boardId, cardId, sectionTypeOwn, 'allowCardCustomProperties');
        const elements = getCustomProperties(state, boardId, cardId);
        const filledCount = sectionType === ESettingsSectionType.POPUP // показать элементы в попапе
            ? 1
            : elements && elements.length
                ? elements.reduce((filledCount, element) => {
                    if (element.value !== null && element.value !== undefined) filledCount++;
                    return filledCount;
                }, 0)
                : 0;
        const hasPinnedProperty = !!elements.filter(item => item.pinned).length;
        const cardCustomPropertyOptions = getBoardCardCustomPropertyOptions(state, boardId);
        const isDefault = !!cardCustomPropertyOptions &&
            !!cardCustomPropertyOptions.length &&
            !!cardCustomPropertyOptions.find(({ isDefault }) => isDefault);

        return {
            elements,
            isDefaultProperty: isDefault,
            isEssentialFeature: getIsUserEssentialPlanOnly(state),
            isProFeature: getShowProFeaturesTrial(state),
            isShow: !!filledCount || hasPinnedProperty || sectionType !== ESettingsSectionType.READONLY && isDefault,
            isHideEmpty: getUserHideEmptyCustomProperties(state),
            sectionType,
        }
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: ICustomPropertiesSectionHOCProps
): ICustomPropertiesSectionEvents => {
    return {
        onAdd: (name, type, options) => dispatch(onAdd(boardId, name, type, options)),
        onClickCancel: () => dispatch(onClickCancel()),
        onClickEdit: () => dispatch(onClickEdit()),
        onConfirmDelete: (customPropertyId) => dispatch(onConfirmDelete(boardId, customPropertyId)),
        onOpen: () => dispatch(onOpen()),
        onHideEmpty: () => dispatch(onHideEmpty()),
        onSave: (elements) => dispatch(onSave(boardId, elements)),
    }
};

export const CustomPropertiesSectionHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomPropertiesSection);

CustomPropertiesSectionHOC.displayName = 'CustomPropertiesSectionHOC';
